import React from "react";
import PubSub from "pubsub-js";
import Skill from "./SkillComponent";

class ProjectComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: true,
            imageVisible: false,
        };

        //this._onMouseOver = this._onMouseOver.bind(this);
    }

    componentDidMount() {
        PubSub.subscribe("SKILL_ON", (msg, data) => {
            const { category } = this.props.project;
            const categoryName = category.data.name[0].text;
            // console.log(categoryName)
            // const category = this.props.node.data.category.document[0].data.name
            //     .text
            if (categoryName === data) {
                this.setState({
                    visible: true,
                });
            } else {
                this.setState({
                    visible: false,
                });
            }
        });

        PubSub.subscribe("SKILL_OFF", (msg, data) => {
            this.setState({
                visible: true,
            });
        });
    }

    componentWillUnmount() {
        PubSub.unsubscribe(this.token);
    }

    // _onMouseOver() {
    //     this.state = {
    //         imageVisible: true,
    //     }
    //     //console.log(this.state.imageVisible)
    // }

    render() {
        // const { project } = this.props
        const { title, url, year, category } = this.props.project;
        // console.log(project)

        // const category = project.category
        //console.log(category)
        let style = this.state.visible
            ? { display: "block" }
            : { display: "none" };

        if (!url) return null;
        // console.log(url)
        return (
            <li className="project-component" style={style} data-year={year}>
                <a href={url[0].text} rel="noopener noreferrer" target="_blank">
                    <sup className="project-year">{year}</sup>
                    <span className="project-name">{title[0].text}</span>
                    {/* <span className="skill">
                        <Skill
                            title={category.data.name[0].text}
                            color={category.data.color[0].text}
                            context="projet"
                        />
                    </span> */}
                    <sup className="skill">
                        <Skill
                            title={category.data.name[0].text}
                            color={category.data.color[0].text}
                            context="projet"
                        />
                    </sup>
                    {/* <img async src={"static/"+item.image} width="200" height="" /> */}
                </a>
            </li>
        );
    }
}

ProjectComponent.displayName = "ProjectComponent";

// Uncomment properties you need
// ProjectComponent.propTypes = {};
// ProjectComponent.defaultProps = {};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/components/ProjectComponent.js